var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 58C45.0163 58 58 45.0163 58 29C58 12.9837 45.0163 0 29 0C12.9837 0 0 12.9837 0 29C0 45.0163 12.9837 58 29 58Z",
    fill: "#F9FAFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.125 25.5C19.7108 25.5 19.375 25.1642 19.375 24.75V22.7501C19.375 22.3359 19.7108 22.0001 20.125 22.0001C20.5392 22.0001 20.875 22.3359 20.875 22.7501V24.75C20.875 25.1642 20.5392 25.5 20.125 25.5Z",
    fill: "#787395"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3331 28.8609C16.3983 29.27 16.1196 29.6544 15.7105 29.7196L13.9774 29.9959C13.5683 30.0611 13.1839 29.7824 13.1187 29.3733C13.0535 28.9643 13.3322 28.5798 13.7413 28.5146L15.4744 28.2383C15.8834 28.1731 16.2679 28.4519 16.3331 28.8609Z",
    fill: "#787395"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4344 26.1707C17.1794 26.4971 16.7081 26.555 16.3817 26.3L13.3194 23.9074C12.993 23.6524 12.9352 23.1811 13.1902 22.8547C13.4452 22.5283 13.9165 22.4704 14.2429 22.7254L17.3052 25.118C17.6316 25.373 17.6894 25.8443 17.4344 26.1707Z",
    fill: "#787395"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9853 16.7438C36.2972 14.6795 39.9377 14.7641 42.1391 16.9394C44.3668 19.1407 44.2697 22.6386 41.9308 24.727L34.6891 31.193C32.3772 33.2573 28.7367 33.1727 26.5353 30.9974C26.2407 30.7063 26.2379 30.2314 26.529 29.9368C26.8202 29.6421 27.295 29.6393 27.5897 29.9305C29.2247 31.5462 31.966 31.6136 33.69 30.0741L40.9318 23.6081C42.6289 22.0928 42.6935 19.596 41.0848 18.0063C39.4497 16.3906 36.7085 16.3232 34.9844 17.8626L30.5309 21.8391C30.222 22.115 29.7478 22.0881 29.472 21.7792C29.1961 21.4702 29.2229 20.9961 29.5319 20.7202L33.9853 16.7438Z",
    fill: "#787395"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.949 40.757C22.7639 42.8318 19.3195 42.7388 17.2483 40.546C15.175 38.3509 15.2622 34.8815 17.4437 32.7944C17.743 32.5081 18.2178 32.5186 18.5041 32.8179C18.7904 33.1172 18.7799 33.592 18.4806 33.8783C16.8953 35.3949 16.8315 37.9201 18.3388 39.516C19.8436 41.1093 22.3445 41.1728 23.9271 39.6588L23.9415 39.6449L30.0093 34.4312C30.3234 34.1612 30.7969 34.197 31.0669 34.5112C31.3368 34.8254 31.301 35.2989 30.9868 35.5688L24.949 40.757ZM23.0547 28.3048C22.7845 27.9908 22.8199 27.5173 23.1338 27.2471L24.2174 26.3143C26.4025 24.2392 29.8471 24.3321 31.9183 26.525C32.2027 26.8261 32.1892 27.3008 31.888 27.5852C31.5869 27.8696 31.1122 27.8561 30.8278 27.555C29.323 25.9617 26.8222 25.8982 25.2396 27.4122L25.2253 27.4259L24.1124 28.3839C23.7985 28.6541 23.3249 28.6187 23.0547 28.3048Z",
    fill: "#787395"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLink);
export default __webpack_public_path__ + "static/media/active-link.1b3bf83c.svg";
export { ForwardRef as ReactComponent };